import { useEffect } from 'react';
import { di } from 'react-magnetic-di';

import { useIssueAdjustmentsActions } from '@atlassian/ui-modifications-core/controllers/issue-adjustments/main';

export const useInitializeNoScreenTab = () => {
	di(useIssueAdjustmentsActions);
	const { initializeNoScreenTab } = useIssueAdjustmentsActions();

	useEffect(() => {
		initializeNoScreenTab();

		// No deps, intialize once
		// oxlint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
